import { CountryPhoneCode } from 'common/enum/country-phone-codes'
import { DateLocales } from 'common/enum/date-locales'
import getAgeByBirthdayDate from 'common/utils/getAgeByBirthdayDate'
import getDateFormattedByLocale from 'common/utils/getDateFormmatedByLocale'
import getPhoneWithCountryCode from 'common/utils/getPhoneWithCountryCode'
import { Patient } from 'domain/entities/patient-model'
import Heading from 'presentation/shared/components/Heading'
import TextField from 'presentation/shared/components/TextField'
import { phoneMask } from 'presentation/utils/masks'
import React from 'react'
import * as S from '../styles'

type Props = {
  patient?: Patient
}

export function AmbulatorySchedulePatientInfo({ patient }: Props) {
  return (
    <>
      <Heading size="large" color="primary" style={{ marginTop: '36px' }}>
        Dados do Paciente
      </Heading>
      <S.Form>
        <div style={{ maxWidth: '335px' }}>
          <TextField label="Paciente" disabled value={patient?.name} />
        </div>
        <div style={{ maxWidth: '200px' }}>
          <TextField
            label="Data de nascimento"
            disabled
            value={getDateFormattedByLocale(
              patient?.birthday,
              DateLocales.ptBr
            )}
          />
        </div>
        <div style={{ maxWidth: '100px' }}>
          <TextField
            label="Idade"
            disabled
            value={getAgeByBirthdayDate(patient?.birthday)}
          />
        </div>
        <div style={{ maxWidth: '160px' }}>
          <TextField label="Sexo" disabled value={patient?.gender} />
        </div>
      </S.Form>
      <S.Form>
        <div style={{ maxWidth: '200px' }}>
          <TextField
            label="Celular"
            disabled
            value={
              patient?.phone
                ? getPhoneWithCountryCode(
                    patient?.phone,
                    CountryPhoneCode.BRAZIL
                  )
                : '-'
            }
            mask={phoneMask}
          />
        </div>
        <div style={{ maxWidth: '180px' }}>
          <TextField
            label="Telefone"
            disabled
            value={
              patient?.landlinePhone
                ? getPhoneWithCountryCode(
                    patient?.landlinePhone,
                    CountryPhoneCode.BRAZIL
                  )
                : '-'
            }
            mask={phoneMask}
          />
        </div>
        <div style={{ maxWidth: '287px' }}>
          <TextField label="E-mail" disabled value={patient?.email} />
        </div>
      </S.Form>
    </>
  )
}
